import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toast } from 'react-toastify';
import { sendEmailService } from '../../utilities/dashboardServices';

export const sendEmail = createAsyncThunk(
    'users/sendEmail', sendEmailService
)


const initialState = {
    loader: false,
}

const emailSendSlice = createSlice({
    name: 'sendEmail',
    initialState,

    reducers: {
       
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendEmail.pending, (state, action) => {
                state.loader=true
            })
            .addCase(sendEmail.fulfilled, (state, action) => {
               if(action.payload.data=="Email sent successfully!"){
                toast.success(action.payload.data)
               }else{
                toast.error(action.payload.data)
               }

                state.loader=false
            })
            .addCase(sendEmail.rejected, (state, action) => {
                toast.error(action.error.message)
                state.loader=false
            })
    },
})

export const {  } = emailSendSlice.actions
export default emailSendSlice.reducer
